export default __webpack_public_path__ + "static/content-1-l5-img-38eb13dd22c832183ac112c42e82d73c.png";